var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1666 5.33594C13.2712 5.33594 14.1666 4.44051 14.1666 3.33594C14.1666 2.23137 13.2712 1.33594 12.1666 1.33594C11.0621 1.33594 10.1666 2.23137 10.1666 3.33594C10.1666 4.44051 11.0621 5.33594 12.1666 5.33594Z",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 10C5.2712 10 6.16663 9.10457 6.16663 8C6.16663 6.89543 5.2712 6 4.16663 6C3.06206 6 2.16663 6.89543 2.16663 8C2.16663 9.10457 3.06206 10 4.16663 10Z",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1666 14.6641C13.2712 14.6641 14.1666 13.7686 14.1666 12.6641C14.1666 11.5595 13.2712 10.6641 12.1666 10.6641C11.0621 10.6641 10.1666 11.5595 10.1666 12.6641C10.1666 13.7686 11.0621 14.6641 12.1666 14.6641Z",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89331 9.00781L10.4466 11.6611",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.44 4.34375L5.89331 6.99708",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d7c48dcc7f90d922ff3fa50345fd0835.svg";
export { ForwardRef as ReactComponent };